import { Stack, Typography } from "@mui/material";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

import { SecurityType } from "./useGetSecuritiest";

interface Props {
	term: string;
}

export default function Option({
	term,
	name,
	isin,
	currency,
	exchange,
	assetType
}: Props & SecurityType) {
	const matches = match(name, term);
	const parts = parse(name, matches);

	return (
		<Stack
			alignItems='center'
			alignSelf='stretch'
			flexDirection='row'
			gap={1}
			justifyContent={"space-between"}
			width={"100%"}
		>
			<Stack alignItems='center' alignSelf='stretch' flexDirection='row' gap={1}>
				<Stack>
					<div>
						{parts.map((part, index) => (
							<Typography
								color={part.highlight ? "primary" : "textPrimary"}
								component='span'
								key={index}
								sx={{ whiteSpace: "pre" }}
								variant='subtitle2'
							>
								{part.text}
							</Typography>
						))}
					</div>
					<Stack>
						<Typography color='text.secondary' variant='body2'>
							{isin}
						</Typography>
						<Typography color='text.secondary' variant='body2'>
							{assetType}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
			<Stack>
				<Typography color='text.secondary' variant='body2'>
					{currency}
				</Typography>
				<Typography color='text.secondary' variant='body2'>
					{exchange}
				</Typography>
			</Stack>
		</Stack>
	);
}
